export default "__VITE_ASSET__DA8WVUpj__"